import { createAsyncThunk } from '@reduxjs/toolkit';
import { EditorType } from '@wix/ambassador-meta-site-search-web/types';

import { GenerateAnswerArticleInput } from '../../../server/service/article';
import { generateAnswer, GenerateAnswerResult } from '../api/generateAnswer';
import { HttpClientFactory } from '../httpClient';

export const loadGenerateAnswer = createAsyncThunk<
  GenerateAnswerResult,
  {
    query: string;
    relatedArticles: GenerateAnswerArticleInput[];
    httpClient: HttpClientFactory;
    editorType: EditorType;
  }
>('loadGenerateAnswer', async ({ query, relatedArticles, httpClient, editorType }) => {
  return generateAnswer(query, relatedArticles, editorType, httpClient);
});
